import React from 'react';
import { Row, Col } from 'antd';
import FeatureList from '../../../shared/FeatureList';

import clubManagersImg from '../../../assets/club-managers-new.png';
import playersImg from '../../../assets/players.png';
import './FeatureSection.css';
import ArrowButton from '../../../shared/ArrowButton';
import '../../../shared/RelatedPulseLinks/RelatedPulseLinks.css';
import {
  Link,
  useNavigate,
} from "react-router-dom";

const managerFeatures = [
  {
    title: 'Automated Game Allocation',
    description:
      'Ensure fair and efficient court assignments with our intelligent Digital Peg Board.',
  },
  {
    title: 'Attendance & Payment Tracking',
    description: 'Monitor player participation and manage payments seamlessly.',
  },
  {
    title: 'Session Management',
    description: 'Organize and oversee club sessions with ease.',
  },
  {
    title: 'Communication Hub',
    description: 'Simplify interactions with players through integrated messaging.',
  },
];

const playerFeatures = [
  {
    title: 'Match History & Stats',
    description: 'Track your performance and game history over time.',
  },
  {
    title: 'Fair Play Assurance',
    description: 'Benefit from equitable game time and balanced matches.',
  },
  {
    title: 'Stay Updated',
    description: 'Receive timely notifications about sessions and club news.',
  },
  {
    title: 'Easy Payments',
    description: 'Manage your session fees effortlessly within the app.',
  },
];

const FeatureSection = () => { 
  const navigate = useNavigate();
  return (
  <div className="feature-section container">
    <Row
      gutter={[64, 64]}
      align="top"
      className="feature-row feature-row--managers"
    >
      <Col xs={{ span: 24, order: 2 }} sm={{ span: 12, order: 1 }}>
        <img
          src={clubManagersImg}
          alt="Club managers"
          className="feature-img"
        />
      </Col>
      <Col xs={{ span: 24, order: 1 }} sm={{ span: 12, order: 2 }}>
        <FeatureList heading="For Club Managers" items={managerFeatures} />
        <ArrowButton 
          variant="white" 
          className="pegboard-highlight-button"
          onClick={() => { 
            navigate("/features/managers")
            document.getElementById('root').scrollTo(0, 0);
          }}
          >
          Find out more
        </ArrowButton>
        <ul className="related-pulse-links__list home-manager-guides">
          <li>
            <Link className="related-pulse-links__link" to="/guides/badminton-club-management-software">
              Badminton club management software guide
            </Link>
          </li>
          <li>
            <Link className="related-pulse-links__link" to="/guides/collect-badminton-club-payments">
              How to collect badminton club payments
            </Link>
          </li>
        </ul>
      </Col>
    </Row>

    <Row
      gutter={[64, 64]}
      align="top"
      className="feature-row feature-row--players"
    >
      <Col xs={{ span: 24, order: 1 }} sm={{ span: 12, order: 1 }}>
        <FeatureList heading="For Players" items={playerFeatures} />
        <ArrowButton 
          variant="white" 
          className="pegboard-highlight-button"
          onClick={() => { 
            navigate("/features/players")
            document.getElementById('root').scrollTo(0, 0);
          }}
          >
          Find out more
        </ArrowButton>
      </Col>
      <Col xs={{ span: 24, order: 2 }} sm={{ span: 12, order: 2 }}>
        <img src={playersImg} alt="Players" className="feature-img" />
      </Col>
    </Row>
  </div>
)
} 

export default FeatureSection;
